import { withTransaction } from '@elastic/apm-rum-react'
import { Button, ButtonBack, Input, LogService, ToastHelper, JessicaJonesService } from '@hub/shared'
import { useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import './forgot-password.page.scss'

const ForgotPasswordPageComponent = () => {
  const logService = useMemo(() => new LogService(), [])
  const navigate = useNavigate()
  const jessicaService = useMemo(() => new JessicaJonesService(), [])
  const { t } = useTranslation('forgotPasswordPage')
  const [loadingButton, setLoadingButton] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [validation, setValidation] = useState<any>({ email: false })
  const [verify, setVerify] = useState({ email: '' })
  const toast = new ToastHelper().toast
  logService.init('ForgotPasswordPage')

  const resetPassword = useCallback(
    async (event: any): Promise<void> => {
      event.preventDefault()
      const email = verify.email
      if (email) {
        try {
          setLoadingButton(true)
          const emailVerify = await jessicaService.passwordRequest(email?.toLowerCase())
          if (emailVerify.message === 'reset_password_email' || emailVerify.message === 'user_not_has_password') {
            toast.success(t('toastMessages.sendResetEmail'), {
              closeButton: true,
              className: 'full text-bold',
              position: `${window.innerWidth > 991 ? 'top' : 'bottom'} center`,
              notOverClick: true,
              immediately: true,
            })
            if (location.origin === history?.state?.usr?.prevPath) {
              history.back()
            } else {
              navigate('/login')
            }
          }
          if (emailVerify.message === 'user_not_registered') {
            toast.warning(t('toastMessages.userNotRegistered', { email: verify.email }), {
              closeButton: true,
              className: 'full text-bold',
              position: `${window.innerWidth > 991 ? 'top' : 'bottom'} center`,
              notOverClick: true,
              immediately: true,
              duration: 3600000,
            })
          }
        } catch (err: any) {
          logService.error({
            message: 'Error to send password reset email',
            user: email,
            error: err,
          })

          if (err?.response) {
            history.pushState({}, '', '/error')
          }
        } finally {
          setLoadingButton(false)
          setDisabled(false)
        }
      }
    },
    [logService, t, jessicaService, verify, toast, navigate]
  )

  const validate = useCallback((): boolean => {
    for (const field in validation) {
      if (validation[field] === false) {
        return false
      }
    }
    return true
  }, [validation])

  return (
    <div>
      <header className="forgot-pasword-header">
        <ButtonBack className="top-back-forgot" onReferrerFalseUrl="/login" />
      </header>
      <h4>{t('recover-password')}</h4>
      <div className="mb-5 px-2">{t('subtitle')}</div>
      <form onSubmit={resetPassword} style={{ width: '100%' }}>
        <Input
          label={t('email')}
          type="email"
          placeholder="email@email.com"
          value={verify.email}
          className="mb-3"
          name="verify-email"
          id="verify-email"
          onChange={(email: string) => setVerify({ ...verify, email })}
          onValidate={(email: boolean) => setValidation({ ...validation, email })}
          autoComplete="email"
          required
        />
        <Button
          type="submit"
          disabled={!validate() || loadingButton || disabled}
          loading={loadingButton}
          className="button-register mb-3"
          size="xl"
          id="button-verify"
          style={{ width: '100%' }}
        >
          {t('send')}
        </Button>
      </form>
    </div>
  )
}

export default withTransaction('ForgotPasswordPageComponent', 'component')(ForgotPasswordPageComponent)
